"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftCardOrderSchema = void 0;
const zod_1 = require("zod");
const types_1 = require("../types");
exports.GiftCardOrderSchema = zod_1.z.object({
    id: zod_1.z.string(),
    claimedAt: zod_1.z.union([zod_1.z.string().datetime(), types_1.FTimestamp]),
    createdAt: types_1.FTimestamp.optional(),
    currency: zod_1.z.string().optional(),
    externalId: zod_1.z.string().optional(),
    giftCardId: zod_1.z.string().nullable(),
    campaignId: zod_1.z.string().nullable().optional(),
    spentCoins: zod_1.z.number().optional(),
    spentPiggyBanks: zod_1.z.number().optional(),
    status: zod_1.z.enum(['Claimed', 'Canceled', 'Declined']),
    totalPrice: zod_1.z.union([zod_1.z.number(), zod_1.z.string()]),
    userId: zod_1.z.string(),
});
